import { STATUS_COMMENT_MAX_LENGTH } from 'constants/constants';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { HeaderCaptionSemiBoldPrimaryBlack } from 'styles/v2/Styles.styled';
import StatusCommentFullViewDialog from '../dialogs/StatusCommentFullViewDialog';

type TProps = {
  licenseeAdminReviewComment: string;
  preserveCommentLineBreaks?: boolean;
};

const LicenseeReviewBox = ({ licenseeAdminReviewComment, preserveCommentLineBreaks }: TProps) => {
  const [showFullCommentDialog, setShowFullCommentDialog] = useState(false);
  const { t } = useTranslation();

  const licenseeAdminReviewCommentPostProcessed =
    licenseeAdminReviewComment &&
    (licenseeAdminReviewComment.length > STATUS_COMMENT_MAX_LENGTH
      ? licenseeAdminReviewComment.slice(0, STATUS_COMMENT_MAX_LENGTH) + '…'
      : licenseeAdminReviewComment);

  return (
    <>
      <ContainerPanel>
        <HeaderCaptionSemiBoldPrimaryBlack>
          {t('epdWizard.epdState.licenseeAdminReviewCommentTitle')}
        </HeaderCaptionSemiBoldPrimaryBlack>
        <span style={{ marginTop: 8 }}>
          {licenseeAdminReviewCommentPostProcessed}{' '}
          {licenseeAdminReviewCommentPostProcessed.length > STATUS_COMMENT_MAX_LENGTH && (
            <LinkSpan onClick={() => setShowFullCommentDialog(true)}>Read more</LinkSpan>
          )}
        </span>
      </ContainerPanel>
      <StatusCommentFullViewDialog
        headerTitle={t('epdWizard.epdState.licenseeAdminReviewCommentTitle')}
        comment={licenseeAdminReviewComment}
        isOpened={showFullCommentDialog}
        onClose={() => setShowFullCommentDialog(false)}
        preserveLineBreaks={preserveCommentLineBreaks}
      />
    </>
  );
};

const ContainerPanel = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.elementsDropDown};
  ${(props) => props.theme.typography.contentInput};
  color: ${(props) => props.theme.colors.primaryBlack70};
`;

const LinkSpan = styled.span`
  color: ${(props) => props.theme.colors.primaryOrange};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${(props) => props.theme.colors.lightOrange};
  }
`;

export default LicenseeReviewBox;
